// extracted by mini-css-extract-plugin
module.exports = {"view-profile-btn":"StudentProfileBox_view-profile-btn__mxwJo","student-profile-row":"StudentProfileBox_student-profile-row__rFzl-"};